export default __webpack_public_path__ + "static/media/nahargharfort.2ababffc.jpg";